var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_302473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2 0C344.2 38 260.1 49.8 236.3 93.7C176.1 204.8 103 204.4 0 194.7V0H356.2Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 287.2V500H0V417.4C99.7 331 238.3 418.2 500 287.2Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8 346.6C83.5 347.1 86.3 344.4 87 340.7L89.1 324.4L93.5 294.2C93.6 293.6 93.4 293.1 93 293.1L91.7 293C91.4 293 91 293.4 90.9 294L86.9 321.2L82.7 320.4L87.8 293C87.9 292.5 87.6 292.1 87.2 292L86.2 291.8C85.8 291.7 85.4 292 85.3 292.5L80.2 319.9L77.1 319.3L82.2 291.9C82.3 291.4 82 291 81.6 290.9L80.6 290.7C80.2 290.6 79.8 290.9 79.7 291.4L74.6 318.8L71 318.1L77.1 291.3C77.2 290.7 77.1 290.2 76.7 290.1L75.4 289.7C75.1 289.6 74.7 290 74.6 290.5L68 319.4C67.9 319.7 67.8 319.9 67.7 320.2L63.9 336.2C63.2 339.9 64.8 343.4 67.5 343.9C68.1 344 68.4 344.7 68.2 345.5L54.1 413.5C52.8 420.4 54.9 426.6 58.8 427.3C62.7 428 66.9 423 68.2 416.1L79.6 347.6C79.7 347.1 80.3 346.5 80.8 346.6Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1 360.5L441.3 360.7C440.6 360.9 439.8 360.4 439.6 359.7L421.2 284.1C421.1 283.5 421.4 283 422 282.9C429.1 281.2 436.3 285.6 438 292.6L451 346C452.5 352.4 448.5 359 442.1 360.5Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.4 427.9L458.2 430.6C456 431.1 453.7 429.8 453.1 427.5L436.1 357.7C435.6 355.5 436.9 353.2 439.2 352.6L450.4 349.9C452.6 349.4 454.9 350.7 455.5 353L472.5 422.8C473.1 425.1 471.7 427.4 469.4 427.9Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.2 368.1C449.967 368.1 451.4 366.667 451.4 364.9C451.4 363.133 449.967 361.7 448.2 361.7C446.433 361.7 445 363.133 445 364.9C445 366.667 446.433 368.1 448.2 368.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.7 386.6C454.467 386.6 455.9 385.167 455.9 383.4C455.9 381.633 454.467 380.2 452.7 380.2C450.933 380.2 449.5 381.633 449.5 383.4C449.5 385.167 450.933 386.6 452.7 386.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.2 405.1C458.967 405.1 460.4 403.667 460.4 401.9C460.4 400.133 458.967 398.7 457.2 398.7C455.433 398.7 454 400.133 454 401.9C454 403.667 455.433 405.1 457.2 405.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7001 349.2C59.7001 337.3 55.2 326.6 47.6 325.3C40 324 32.1001 332.6 30.1001 344.4C28.6001 353.3 30.8001 361.6 35.2001 365.7L25.8 414.2C24.9 419.7 27.0001 424.8 30.5001 425.4C34 426 37.7 422 38.6 416.4L45.8 367.5C51.4 365.2 56.2001 358.2 57.7001 349.2Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.6 405.9C323.943 405.9 383.4 381.365 383.4 351.1C383.4 320.835 323.943 296.3 250.6 296.3C177.257 296.3 117.8 320.835 117.8 351.1C117.8 381.365 177.257 405.9 250.6 405.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 304.2C130.2 268.4 189.5 245 250 245C310.5 245 369.8 268.4 385.5 304.2C405.9 350.7 348.1 400.2 250 400.2C152 400.1 94.1 350.7 114.5 304.2Z",
    fill: "#A6A5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 298.7C130.2 262.9 189.5 239.5 250 239.5C310.5 239.5 369.8 262.9 385.5 298.7C405.9 345.2 348.1 394.7 250 394.7C152 394.6 94.1 345.2 114.5 298.7Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1 298.1C174 275.4 211.7 260.6 250 260.6C288.3 260.6 326 275.5 335.9 298.1C348.8 327.6 312.2 359 250 359C187.8 359 151.1 327.6 164.1 298.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5 193.4C119.7 215.9 110.5 243.3 110.5 272.9C110.5 349.5 172.6 375.9 249.2 375.9C311.5 375.9 364.2 353.2 381.7 309.3C385.7 299.2 387.9 287.2 387.9 272.9C387.9 243.3 378.6 215.9 362.9 193.4H135.5Z",
    fill: "#A6A5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8 136.4C290.7 132.9 291.2 129.3 291.2 125.5C291.2 102.3 272.3 83.4 249.1 83.4C225.9 83.4 207 102.3 207 125.5C207 129.3 207.5 132.9 208.4 136.4C199.9 139 191.7 142.4 184 146.5C140.2 169.8 110.4 215.9 110.4 269C110.4 322.2 140.3 351.1 184.2 363.9C203.6 369.5 225.6 372 249.1 372C311.4 372 364.1 349.3 381.6 305.4C385.6 295.3 387.8 283.3 387.8 269C387.8 206.6 346.5 153.8 289.8 136.4ZM271.5 132.2C264.2 131 256.8 130.4 249.2 130.4C241.6 130.4 234.1 131 226.8 132.2C226.2 130.1 225.8 127.9 225.8 125.6C225.8 112.7 236.3 102.3 249.1 102.3C262 102.3 272.4 112.8 272.4 125.6C272.4 127.8 272.1 130.1 271.5 132.2Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.6 307.9C169.1 327.9 177.1 346.8 184.2 363.9C140.3 351.1 110.4 322.2 110.4 269C110.4 215.9 140.2 169.8 184 146.5C191.7 142.4 199.9 139 208.4 136.4C208.5 136.4 130.1 186.1 163.6 307.9Z",
    fill: "#A6A5C2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344 214.4C339.6 214.4 336 211 335.6 206.6C334.4 191.1 310.6 175.2 301.5 170.4C297.4 168.2 295.8 163.2 298 159.1C300.2 155 305.2 153.4 309.3 155.6C313.5 157.8 350.3 177.9 352.3 205.4C352.6 210 349.2 214.1 344.5 214.4C344.4 214.4 344.2 214.4 344 214.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 122.2C280.6 122.2 279.4 121.2 279.1 119.8C275.7 99.2 255 94.1 254.1 93.8C252.5 93.4 251.6 91.9 251.9 90.3C252.3 88.7 253.8 87.8 255.4 88.1C256.4 88.3 280.8 94.3 284.9 118.8C285.2 120.4 284.1 121.9 282.5 122.2C282.3 122.2 282.1 122.2 282 122.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_302473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.eb9b5b46.svg";
export { ForwardRef as ReactComponent };